import { DataGridProps } from "@mui/x-data-grid";


export const datagridProps: Partial<DataGridProps> = {
    checkboxSelection: true,
    disableColumnMenu: true
};
